import { Component } from '@angular/core';

@Component({
  selector: 'app-description-list',
  templateUrl: './description-list.component.html',
  styleUrl: './description-list.component.scss',
  standalone: true,
})
export class DescriptionListComponent {}
